import { render } from "./suspension.vue?vue&type=template&id=58553c2e&scoped=true"
const script = {}

import "./suspension.vue?vue&type=style&index=0&id=58553c2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58553c2e"]])

export default __exports__